<app-filters-checkbox-item
    [attr.title]="'filters.shared.organizationFilters.myOrganization' | translate"
    [option]="organizationFilterItem"
    (selectionChange)="onOrganizationSelectionChanged()"
></app-filters-checkbox-item>
